<template>
 <HelloWorld/>


</template>

<script>

import HelloWorld from "./components/HelloWorld";


export default {
  name: 'App',
  components: {
     HelloWorld,
  },

data() {
    return {
      tabList: ["Policies & procedures", "Risk Assessments", "Training & Awareness", "Record Keeping & Reporting", "Client Due Diligence",],
    };
  },
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
